/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-06-14 17:45:57
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2024-11-23 16:43:07
 * @FilePath: \baishu_react_ui\src\components\BsyBatchEditPane\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from "react";
import { BsyUtils } from "../../utils/Utils";
import BsyDept from "../BsyDept";
import BsyDialog from "../BsyDialog";
import BsyIconBtn from "../BsyIconBtn";
import BsySelect from "../BsySelect";
import BsySLoading from "../BsySLoading";
import BsyUser from "../BsyUser";
import { BsyWidget } from "../BsyWidget";
import "./index.css";
import { dayjsUtils } from "../../utils/dayjsUtils";

export default class BsyExcelGrid extends BsyWidget {
  static defaultProps = {
    baseCls: "bsy-excel-grid",
  };
  constructor(props) {
    super(props);
    this.state = {
      skip: 0,
      limit: 30,
      maxCol: 100,
      items: [],
      heads: [],
      match: [],
      importCheckallowBlank: !1,
      importCheckrepeat: !1,
      showHead: !1,
      matchWidgets: [],
      widgetsMap: {},
      createColWidget: !1,
      headEnable: !1,
      importMode: 0,
      onUpdateError: null,
      allowWidgets: [
        {
          value: "text",
          text: React.language("widget.text"),
        },
        {
          value: "number",
          text: React.language("widget.number"),
        },
        {
          value: "textarea",
          text: React.language("widget.textarea"),
        },
        {
          value: "datetime",
          text: React.language("datetime"),
        },
        {
          value: "radiogroup",
          text: React.language("widget.radiogroup"),
        },
        {
          value: "checkboxgroup",
          text: React.language("widget.checkboxgroup"),
        },
        {
          value: "combo",
          text: React.language("widget.combo"),
        },
        {
          value: "combocheck",
          text: React.language("widget.combocheck"),
        },
        {
          value: "user",
          text: React.language("member"),
        },
        {
          value: "usergroup",
          text: React.language("widget.usergroup"),
        },
        {
          value: "dept",
          text: React.language("department"),
        },
        {
          value: "deptgroup",
          text: React.language("widget.deptgroup"),
        },
      ],
      userDeptWidgets: [
        "user",
        "usergroup",
        "dept",
        "deptgroup",
        "number",
        "textarea",
        "text",
        "datetime",
        "combo",
        "combocheck",
        "radiogroup",
        "checkboxgroup",
      ],
      formId: null,
      async: null,
      onAsyncSuccess: null,
      onAsyncFail: null,
      onRowClick: null,
      onCheckData: null, // 单个元素验证重复值
      excelData: {},
      errorData: null,
      ...props,
    };

    this.element = React.createRef();
  }

  componentDidMount() {
    super.componentDidMount();
    this.props.onAsyncSuccess && this.props.onAsyncSuccess();
  }

  getColumnMatch = (importCheckallowBlank, importCheckrepeat) => {
    const { heads, widgetsMap } = this.state;

    let newHeader = [];

    for (let index = 0; index < heads.length; index++) {
      let element = { ...heads[index] };
      if (element.subColumns) {
        element.subColumns = [];
        for (let j = 0; j < heads[index].subColumns.length; j++) {
          let subel = { ...heads[index].subColumns[j] };
          if (subel.match) {
            let field = subel.match.field;
            if (subel.match.part) {
              field = [subel.match.field, subel.match.part].join("-");
            }
            if (widgetsMap[field]) {
              if (importCheckallowBlank) {
                subel.match.allowBlank = widgetsMap[field].allowBlank;
              }
              if (importCheckrepeat) {
                subel.match.noRepeat = widgetsMap[field].noRepeat;
              }
              if (subel.match.type === "address") {
                let part = field.split("-")[1];
                field = field.split("-")[0];
                subel.match.part = part;
                subel.match.field = field;
              }
              element.subColumns.push(subel);
              if (!element.match) {
                let subform = widgetsMap[field].subform;
                element.match = {
                  field: subform,
                  text: widgetsMap[subform].text, //"子表单单行必填1",
                  type: "subform",
                };
              }
            }
          }
        }
        if (element.subColumns.length) {
          newHeader.push(element);
        }
      } else {
        if (element.match) {
          let field = element.match.field;
          if (element.match.part) {
            field = [element.match.field, element.match.part].join("-");
          }
          if (widgetsMap[field]) {
            if (importCheckallowBlank) {
              element.match.allowBlank = widgetsMap[field].allowBlank;
            }
            if (importCheckrepeat) {
              element.match.noRepeat = widgetsMap[field].noRepeat;
            }
            if (element.match.type === "address") {
              let part = field.split("-")[1];
              field = field.split("-")[0];
              element.match.part = part;
              element.match.field = field;
            }

            newHeader.push(element);
          }
        }
      }
    }
    return newHeader;
  };

  getFixedDataList = () => {
    const { errorData, widgetsMap } = this.state;
    let that = this;
    let dc = this.element.current.querySelectorAll(".style-check-error");
    let dcl = dc.length;
    for (let i = 0; i < dc.length; i++) {
      dc[i].classList.value.indexOf("number") > -1 && dcl--;
    }
    let dcuserdeptError = this.element.current.querySelectorAll(
      ".style-check-userdept"
    );
    let error = dcl + dcuserdeptError.length;

    let newValue = {};

    for (let index = 0; index < errorData.length; index++) {
      const element = errorData[index];
      let key = element.row;
      let newData = {};
      BsyUtils.forEach(element, (key, data) => {
        if (key === "row") return;
        let fiexdata = that.fixedWidgetMap[index][key];
        if (that.fixedWidgetMap[index][key]) {
          switch (widgetsMap[key].type) {
            case "subform": {
              newData[key] = [];
              if (data) {
                for (let i = 0; i < data.length; i++) {
                  let subrowdata = fiexdata[i];
                  let subnewdata = {};
                  BsyUtils.forEach(data[i], (subkey, subdata) => {
                    if (subrowdata[subkey]) {
                      switch (widgetsMap[subkey].type) {
                        case "usergroup":
                        case "deptgroup": {
                          let vals = [];
                          for (let i = 0; i < subrowdata[subkey].length; i++) {
                            if (
                              !subrowdata[subkey][i].isMiss &&
                              !subrowdata[subkey][i].isRepeat
                            ) {
                              vals.push(
                                subrowdata[subkey][i].id ||
                                subrowdata[subkey][i]._id
                              );
                            }
                          }
                          if (!BsyUtils.isObjectEmpty(vals))
                            subnewdata[subkey] = vals;
                          break;
                        }
                        default: {
                          if (!BsyUtils.isObjectEmpty(subrowdata[subkey]))
                            subnewdata[subkey] = subrowdata[subkey];
                        }
                      }
                    } else {
                      // subnewdata[subkey] = null;
                    }
                  });
                  if (!BsyUtils.isObjectEmpty(fiexdata))
                    newData[key].push(subnewdata);
                }
              }

              break;
            }
            case "user":
            case "dept": {
              if (!BsyUtils.isObjectEmpty(fiexdata)) newData[key] = fiexdata;
              break;
            }
            case "usergroup":
            case "deptgroup": {
              let vals = [];
              for (let i = 0; i < fiexdata.length; i++) {
                if (!fiexdata[i].isMiss && !fiexdata[i].isRepeat) {
                  vals.push(fiexdata[i].id || fiexdata[i]._id);
                }
              }
              if (!BsyUtils.isObjectEmpty(vals)) newData[key] = vals;
              break;
            }
            default: {
              if (!BsyUtils.isObjectEmpty(fiexdata)) newData[key] = fiexdata;
            }
          }
        } else {
          // newData[key] = null;
        }
      });
      if (!BsyUtils.isObjectEmpty(newData)) newValue[key] = newData;
    }
    return [error, { ...newValue }, dcl, dcuserdeptError.length];
  };

  getWidgetName = (e) => {
    const { widgetsMap } = this.state;

    if (!e.match) return "0";
    var i;
    switch (e.match.type) {
      case "address":
      case "location":
        if (e.match.field.indexOf("-") === -1)
          i = [e.match.field, e.match.part].join("-");
        else i = e.match.field;
        break;
      default:
        i = e.match.field;
    }
    return widgetsMap[i] ? i : "0";
  };

  renderWidgetHerder = () => {
    const { matchWidgets, widgetsMap, headEnable } = this.state;
    let heads = this.state.heads;
    this.headerdata = [];
    for (let i = 0; i < heads.length; i++) {
      if (heads[i].hasOwnProperty("subColumns")) {
        for (let j = 0; j < heads[i].colspan; j++) {
          this.headerdata.push({
            ...heads[i].subColumns[j],
            hasSubform: true,
            match: heads[i].subColumns[j]
              ? heads[i].subColumns[j].match || {}
              : {},
          });
        }
      } else {
        this.headerdata.push(heads[i]);
      }
    }

    if (!headEnable) {
      return "";
    }

    return (
      <tr>
        <td className="row-idx">
          <span> {React.language("form.fields")}</span>
        </td>
        {this.headerdata.map((header) => {
          let items = [
            {
              value: "0",
              text: React.language("import.notAllowed"),
            },
            ...matchWidgets,
          ];

          if (header.hasSubform) {
            items = [
              {
                value: "0",
                text: React.language("import.notAllowed"),
              },
            ];
            for (let i = 0; i < matchWidgets.length; i++) {
              if (widgetsMap[matchWidgets[i].value].subform) {
                items.push(matchWidgets[i]);
              }
            }
          }

          return (
            <td>
              <BsySelect
                allowBlank={false}
                searchable={false}
                value={this.getWidgetName(header)}
                items={items}
                onStopEdit={(val) => {
                  let newheads = [...heads];

                  let isSubform = header.hasSubform;

                  //重置字段信息
                  for (let i = 0; i < newheads.length; i++) {
                    if (isSubform) {
                      if (newheads[i].hasOwnProperty("subColumns")) {
                        for (let j = 0; j < newheads[i].colspan; j++) {
                          if (j >= newheads[i].subColumns.length) {
                            break;
                          }

                          if (header.col === newheads[i].subColumns[j].col) {
                            if (val == 0) {
                              newheads[i].subColumns[j].match = null;
                            } else {
                              if (!newheads[i].subColumns[j].match) {
                                newheads[i].subColumns[j].match = {
                                  type: widgetsMap[val].type,
                                  text: header.match ? header.match.text : null,
                                  field: val,
                                };
                              } else {
                                newheads[i].subColumns[j].match.field = val;
                                newheads[i].subColumns[j].match.type =
                                  widgetsMap[val].type;
                              }
                            }
                          } else {
                            if (
                              newheads[i].subColumns[j].match &&
                              newheads[i].subColumns[j].match.field == val
                            ) {
                              newheads[i].subColumns[j].match.field = "0";
                            }
                          }
                        }
                      }
                    } else {
                      if (header.col === newheads[i].col) {
                        if (val == 0) {
                          newheads[i].match = null;
                        } else {
                          if (!newheads[i].match) {
                            newheads[i].match = {
                              type: widgetsMap[val].type,
                              text: header.match ? header.match.text : null,
                              field: val,
                            };
                          } else {
                            newheads[i].match.field = val;
                            newheads[i].match.type = widgetsMap[val].type;
                          }
                        }
                      } else {
                        if (
                          newheads[i].match &&
                          newheads[i].match.field == val
                        ) {
                          newheads[i].match.field = "0";
                        }
                      }
                    }
                  }

                  // if (val == "0") {
                  //     if (header.match)
                  //         header.match.field = val;
                  //     this.setState({
                  //         heads: newheads
                  //     })
                  //     return
                  // }

                  // header.match = {
                  //     type: widgetsMap[val].type,
                  //     text: header.match ? header.match.text : null,
                  //     field: val
                  // }

                  // // if (widgetsMap[val].type === 'address') {
                  // //     header.match.part = widgetsMap[val].part
                  // // }

                  // if (widgetsMap[val].subform) {
                  //     // header.subform = widgetsMap[val].subform;
                  // }

                  // for (let i = 0; i < this.headerdata.length; i++) {
                  //     if (this.headerdata[i].col !== header.col) {
                  //         if (this.headerdata[i].match && this.headerdata[i].match.field === val) {
                  //             this.headerdata[i].match.field = "0"
                  //         }
                  //     }
                  // }
                  this.setState(
                    {
                      heads: newheads,
                    },
                    () => {
                      this.props.onAsyncSuccess && this.props.onAsyncSuccess();
                    }
                  );
                }}
              ></BsySelect>
            </td>
          );
        })}
      </tr>
    );
  };

  renderHeader = () => {
    const { hasSubform, items, heads, showHead } = this.state;
    let headerdata = [];
    if (items.length === 0) {
      return <></>;
    }

    if (showHead) {
      headerdata = [[]];
      if (hasSubform) {
        headerdata = [[], []];
      }

      for (let i = 0; i < heads.length; i++) {
        if (hasSubform) {
          if (heads[i].hasOwnProperty("subColumns")) {
            for (let j = 0; j < heads[i].colspan; j++) {
              if (j === 0) {
                headerdata[0].push({
                  value: heads[i].text,
                  colspan: heads[i].colspan,
                  hasSubform: true,
                });
              } else {
                headerdata[0].push([]);
              }
              headerdata[1].push({
                value: heads[i].subColumns[j]
                  ? heads[i].subColumns[j].text
                  : "",
                hasSubform: true,
              });
            }
          } else {
            headerdata[0].push({
              value: heads[i] ? heads[i].text : "",
              rowspan: 2,
            });
            headerdata[1].push([]);
          }
        } else {
          headerdata[0].push({
            value: heads[i] ? heads[i].text : "",
          });
        }
      }
    } else {
      headerdata = [items[0]];
      if (hasSubform) {
        headerdata.push(items[1]);
      }
    }

    return (
      <>
        {headerdata.map((item, index) => {
          return (
            <tr className={"row-head"}>
              {index === 0 ? (
                <td rowSpan={hasSubform ? 2 : 1} className={"row-idx"}>
                  <span>
                    {" "}
                    {showHead ? "" : React.language("import.rowHead")}
                  </span>
                </td>
              ) : (
                ""
              )}

              {item.map((id) => {
                if (Array.isArray(id)) {
                  return "";
                }

                return (
                  <td colSpan={id.colspan} rowSpan={id.rowspan}>
                    <span>{id.value}</span>
                  </td>
                );
              })}
            </tr>
          );
        })}
        {showHead && this.renderWidgetHerder()}
      </>
    );
  };

  colLabelTd = (id) => {
    const { widgetsMap } = this.state;
    let text = "";
    let isErrorType = "";
    let widget = this.findHeader(id);
    if (id.value.hasOwnProperty("errors")) {
      BsyUtils.forEach(id.value.errors, (key, error) => {
        if (error.hasOwnProperty("col")) {
          if (error.col === id.col) {
            if (error.isallowBlank) {
              isErrorType = "style-check-error";
              text = React.language("import.contact.isallowBlank");
            }
            if (error.isIllegal) {
              isErrorType = "style-check-error";
              text = error.err;
            }
            return false;
          }
        }
      });
    }

    if (id.value.isallowBlank) {
      isErrorType = "style-check-error";
      text = React.language("import.contact.isallowBlank");
    }
    if (id.value.isIllegal) {
      if (id.col === id.value.col) {
        isErrorType = "style-check-error";
        text = id.value.err;
      }
    }
    if (id.value.isnoRepeat) {
      isErrorType = "style-check-error";
      text = React.language("import.contact.isnoRepeat");
    }
    if (id.value.isMiss) {
      isErrorType = "style-check-userdept";
      text = React.language("import.contact.empty", { name: id.value.text });
    }
    if (id.value.isRepeat) {
      isErrorType = "style-check-userdept";
      text = React.language("import.contact.multi", { name: id.value.text });
    }

    if (Array.isArray(id.value.value) && id.value.value.length > 0) {
      let error = false;
      let names = [];
      for (let index = 0; index < id.value.value.length; index++) {
        const element = id.value.value[index];
        if (element.isRepeat || element.isMiss) {
          isErrorType = "style-check-userdept";
          error = true;
        }
        names.push(element.name);
      }

      //import.user.fail
      //widgetsMap[widget.match.field]
      if (error) {
        if (widgetsMap[widget.match.field].type === "usergroup") {
          text = React.language("import.user.fail");
        } else {
          text = React.language("import.dept.fail");
        }
      } else {
        return <span className="td-text">{names.join("、")}</span>;
      }
    }

    if (text === "" && id.value.text) {

      if (widget) {
        if (widget.match.part) {
          return <span></span>;
        }
        return (
          <span>{id.value.text ? id.value.text[widget.match.part] : ""}</span>
        );
      }
      return <span>{id.value.text}</span>;
    }

    return (
      <div
        className={
          "col-label " +
          (text ? isErrorType : "") +
          " " +
          (widget ? (widget.match ? widget.match.type : "") : "")
        }
      >
        {text}
      </div>
    );
  };

  findLabelElement = (element) => {
    let el = BsyUtils.closestClass(element, "td-cell");
    if (el) {
      return el.querySelector(".col-label");
    }
    return null;
  };

  findTdElement = (element) => {
    let el = BsyUtils.closestClass(element, "td-cell");
    return el;
  };

  selectUserDeptPane = (field, value, cb) => {
    const { widgetsMap } = this.state;
    let type = widgetsMap[field].type;

    BsyDialog({
      title: React.language("import.fail.view"),
      width: 600,
      height: 500,
      noFooter: true,
      onContentCreate: (el) => {
        return (
          <BsyFixedContent
            key={"showdd" + new Date().getTime()}
            values={value}
            type={type}
            onOk={(val) => {
              cb && cb([...val]);
              el.closeAlter();
            }}
            onCancel={() => {
              el.closeAlter();
            }}
          />
        ); // this._createMain(field, value, e)
      },
    });
  };

  setTdValue = (id, widget, value) => {
    if (widget.subform) {
      // this.fixedWidgetMap[widget.subform] = this.fixedWidgetMap[widget.subform] || []
      switch (widget.type) {
        case "checkboxgroup":
        case "combocheck":
        case "usergroup":
        case "deptgroup": {
          this.fixedWidgetMap[id.row][widget.subform][id.subrow][
            widget.match.field
          ] = value ? [...value] : [];
          break;
        }
        default: {
          this.fixedWidgetMap[id.row][widget.subform][id.subrow][
            widget.match.field
          ] = value;
        }
      }
    } else {
      switch (widget.type) {
        case "checkboxgroup":
        case "combocheck":
        case "usergroup":
        case "deptgroup": {
          this.fixedWidgetMap[id.row][widget.match.field] = value
            ? [...value]
            : [];
          break;
        }
        default: {
          this.fixedWidgetMap[id.row][widget.match.field] = value;
        }
      }
    }
    if (this.state.onUpdateError) {
      this.state.onUpdateError();
    }
  };

  //先判断在当前界面上的值是否 有重复
  checkLocalRepeatValue = (id, widget, value) => {
    let issame = false;
    let that = this;
    if (widget.subform) {
      BsyUtils.forEach(that.fixedWidgetMap, (row, rowdata) => {
        if (rowdata[widget.subform]) {
          BsyUtils.forEach(rowdata[widget.subform], (subrow, subrowdata) => {
            //忽略自己这一行的数据
            if (row == id.row && subrow == id.subrow) {
              return true;
            }
            if (subrowdata[widget.match.field] == value) {
              issame = true;
              return false;
            }
          });
          if (issame) {
            return false;
          }
        }
      });
    } else {
      BsyUtils.forEach(that.fixedWidgetMap, (row, rowdata) => {
        //忽略自己这一行的数据
        if (row == id.row) {
          return true;
        }
        if (rowdata[widget.match.field] == value) {
          issame = true;
          return false;
        }
      });
    }
    return issame;
  };

  findHeader = (id) => {
    //widget = this.headerdata[id.value.col];
    let col = id
      ? id.hasOwnProperty("col")
        ? id.col
        : id.value
          ? id.value.col
          : null
      : null;
    let widget = this.headerdata[col];

    if (widget && widget.col === col) {
      return widget;
    } else {
      widget = null;
    }
    BsyUtils.forEach(this.headerdata, (a1, b1) => {
      if (col === b1.col) {
        widget = b1;
        return false;
      }
    });
    return widget;
  };



  colCellTd = (id) => {
    const { widgetsMap, errorData } = this.state;

    let that = this;
    let widget = null;
    if (Array.isArray(id.value.value) && id.value.value.length > 0) {
      let error = false;
      let names = [];
      for (let index = 0; index < id.value.value.length; index++) {
        const element = id.value.value[index];
        if (element.isRepeat || element.isMiss) {
          error = true;
        }
        names.push(element.name);
      }
      if (!error) {
        return "";
      }

      widget = this.findHeader(id); // this.headerdata[id.value.col];
      return (
        <div className="excel-grid-cell bsy-excel-userdept-fixed">
          <div
            className="fixed-btn"
            onClick={(e) => {
              var currentTarget = e.currentTarget;
              var cellval = null;

              if (widget.subform) {
                // this.fixedWidgetMap[widget.subform] = this.fixedWidgetMap[widget.subform] || []
                cellval =
                  that.fixedWidgetMap[id.row][widget.subform][id.subrow][
                  widget.match.field
                  ];
              } else {
                cellval = that.fixedWidgetMap[id.row][widget.match.field];
              }
              cellval = cellval || id.value.value;
              that.selectUserDeptPane(widget.match.field, cellval, (val) => {
                var errorLabelElement = that.findLabelElement(currentTarget);
                if (errorLabelElement) {
                  let error = false;
                  for (let i = 0; i < val.length; i++) {
                    if (val[i].isMiss || val[i].isRepeat) {
                      error = true;
                      break;
                    }
                  }
                  if (!error) {
                    errorLabelElement.classList.remove("style-check-error");
                    errorLabelElement.classList.remove("style-check-userdept");
                    errorLabelElement.innerHTML = React.language("updated");
                  }
                  that.setTdValue(id, widget, val);
                }
              });
            }}
          >
            {React.language("import.failDetail.view")}
          </div>
        </div>
      );
    }

    widget = this.findHeader(id); //this.headerdata[id.value.col];

    if (!widget) {
      return "";
    }

    let res = {
      onStopEdit: (val, sec, context) => {
        //此处 使用数据驱动的方式，逻辑会非常复杂，直接复杂元素修改的方式达到效果
        var errorLabelElement = this.findLabelElement(context.element.current);
        if (id.value.isallowBlank) {
          if (!BsyUtils.isObjectEmpty(val)) {
            errorLabelElement.classList.remove("style-check-error");
            errorLabelElement.innerHTML = React.language("updated");
          } else {
            errorLabelElement.classList.add("style-check-error");
            errorLabelElement.innerHTML = React.language(
              "import.contact.isallowBlank"
            );
          }
          that.setTdValue(id, widget, val);
          return;
        }
        if (id.value.isMiss || id.value.isRepeat) {
          //部门成员单选的错误信息处理
          errorLabelElement.classList.remove("style-check-error");
          errorLabelElement.classList.remove("style-check-userdept");
          errorLabelElement.innerHTML = React.language("updated");
          that.setTdValue(id, widget, val);
          return;
        }
        if (id.value.isnoRepeat) {
          //验证重复值
          if (!BsyUtils.isObjectEmpty(val)) {
            let tdel = that.findTdElement(context.element.current);

            if (that.checkLocalRepeatValue(id, widget, val)) {
              //本地错误值中有重复
              errorLabelElement.classList.add("style-check-error");
              errorLabelElement.innerHTML = React.language(
                "import.contact.isnoRepeat"
              );
              return;
            }

            tdel && tdel.classList.add("loading");
            BsyUtils.applyFunc(
              that,
              that.options.onCheckData,
              [
                {
                  cellcol: {
                    ...widget,
                    row: id.value.row,
                  },
                  value: val,
                },
                (res) => {
                  tdel && tdel.classList.remove("loading");

                  if (res.errCode === 0) {
                    errorLabelElement.classList.remove("style-check-error");
                    errorLabelElement.innerHTML = React.language("updated");
                  } else {
                    errorLabelElement.classList.add("style-check-error");
                    errorLabelElement.innerHTML =
                      res.errMsg || React.language("import.contact.isnoRepeat");
                  }
                  that.setTdValue(id, widget, val);
                },
              ],
              !1
            );
          }
          return;
        }
        that.setTdValue(id, widget, val);
        return;
        // console.log(val)
      },
    };

    if (!widget.match) {
      return <div className="excel-grid-cell">{id?.value?.text}</div>;
    }
    let dfield = widget.match.field;
    let type = widget.match.type;
    let subform = widget.subform;
    let title = null;
    if (errorData) {
      const error = errorData.find((it) => {
        const row = id.hasOwnProperty("row") ? id.row : id.value.row;
        const errorRow =
          typeof it.row === "string"
            ? parseInt(it.row.replace("row_", ""))
            : it.row;
        return (it[dfield] && it[dfield].row === row) || errorRow === id.row;
      });
      if (!error) {
        // 无错误信息
        if (type === "address") {
          title = id.value
            ? id.value.text
              ? id.value.text[widget.match.part]
              : ""
            : "";
        } else {
          title = id.value ? id.value.text : "";
        }
      } else if (
        !subform
          ? !error[dfield]
          : !error[subform] ||
          !error[subform][id.subrow] ||
          !error[subform][id.subrow][dfield]
      ) {
        // 错误信息未匹配到
        if (type === "address") {
          title = id.value
            ? id.value.text
              ? id.value.text[widget.match.part]
              : ""
            : "";
        } else {
          title = id.value ? id.value.text : "";
        }
      } else if (
        !subform
          ? error[dfield] && error[dfield].errors
          : error[subform] &&
          error[subform][id.subrow] &&
          error[subform][id.subrow][dfield] &&
          error[subform][id.subrow][dfield].errors
      ) {
        // 地址字段独有的错误

        let errors = !subform
          ? error[dfield] && error[dfield].errors
          : error[subform] &&
          error[subform][id.subrow] &&
          error[subform][id.subrow][dfield] &&
          error[subform][id.subrow][dfield].errors;

        let isCol = false;
        BsyUtils.forEach(errors, (key, error) => {
          if (error.hasOwnProperty("col")) {
            if (error.col === id.col) {
              isCol = true;
              return false;
            }
          }
        });
        if (isCol) {
          if (widget.subform) {
            if (
              this.fixedWidgetMap[id.row] &&
              this.fixedWidgetMap[id.row][widget.subform] &&
              this.fixedWidgetMap[id.row][widget.subform][id.subrow]
            ) {
              if (
                !this.fixedWidgetMap[id.row][widget.subform][id.subrow][
                widget.match.field
                ]
              ) {
                this.fixedWidgetMap[id.row][widget.subform][id.subrow][
                  widget.match.field
                ] = {
                  ...(id.value.text ? id.value.text : {}),
                };
              }
              this.fixedWidgetMap[id.row][widget.subform][id.subrow][
                widget.match.field
              ][widget.match.part] = "";
            }
          } else {
            if (this.fixedWidgetMap[id.row]) {
              if (!this.fixedWidgetMap[id.row][widget.match.field]) {
                this.fixedWidgetMap[id.row][widget.match.field] = {
                  ...(id.value.text ? id.value.text : {}),
                };
              }
              this.fixedWidgetMap[id.row][widget.match.field][
                widget.match.part
              ] = "";
            }

            // this.fixedWidgetMap[id.row] &&
            //   (this.fixedWidgetMap[id.row][widget.match.field] = {
            //     ...(id.value.text ? id.value.text : {}),
            //   });
          }
        }

        title = id.value
          ? id.value.text
            ? id.value.text[widget.match.part]
            : ""
          : "";


        if (title) {
          if (['user', 'dept', 'usergroup', 'deptgroup'].includes(type)) {
            console.log(title, id)
            if (id.value.isMiss || id.value.isRepeat || id.value.isnoRepeat) {

            } else {
              return <div className="excel-grid-cell error">{title}</div>;
            }
          } else {
            return <div className="excel-grid-cell error">{title}</div>;
          }
        } else {
          if (['user', 'dept', 'usergroup', 'deptgroup'].includes(type)) {
            if (id.value.isMiss || id.value.isRepeat || id.value.isnoRepeat) {

            } else {
              return <div className="excel-grid-cell error">{id.value.text}</div>;
            }
          }
        }
      } else if (
        !subform
          ? !error[dfield].isMiss && !error[dfield].isRepeat
          : error[subform] &&
          error[subform][id.subrow] &&
          error[subform][id.subrow][dfield] &&
          !error[subform][id.subrow][dfield].isMiss &&
          !error[subform][id.subrow][dfield].isRepeat
      ) {
        let fd = !subform
          ? error[dfield]
          : error[subform] &&
          error[subform][id.subrow] &&
          error[subform][id.subrow][dfield];
        title = (fd && fd.nickname) || id.value ? id.value.text : "";
      }

      if (title) {
        if (['user', 'dept', 'usergroup', 'deptgroup'].includes(type)) {
          console.log(title, id)
          if (id.value.isMiss || id.value.isRepeat || id.value.isnoRepeat) {

          } else {
            return <div className="excel-grid-cell error">{title}</div>;
          }
        } else {
          return <div className="excel-grid-cell error">{title}</div>;
        }
      } else {
        if (['user', 'dept', 'usergroup', 'deptgroup'].includes(type)) {
          if (id.value.isMiss || id.value.isRepeat || id.value.isnoRepeat) {

          } else {
            return <div className="excel-grid-cell error">{id.value.text}</div>;
          }
        }
      }
    }

    if (widget.match.part) {
      dfield = [widget.match.field, widget.match.part].join("-");
      return (
        <div className="excel-grid-cell">
          {id.value.text ? id.value.text[widget.match.part] : ""}
        </div>
      );
    }
    let ord = widgetsMap[dfield];
    if (!ord) {
      return;
    }
    switch (ord.type) {
      case "textarea": {
        res.width = "100%";
        break;
      }
      case "subform": {
        // 子表单，不能在错误信息中展示 ，直接屏蔽了
        return
      }
      default: {
      }
    }
    res.type = ord.type;
    res.format = ord.format;
    res.allowBlank = ord.allowBlank;
    res.items = ord.items;
    res.value =
      res.type === "number"
        ? BsyUtils.toNumberString(id.value.text)
        : id.value.text;

    if (res.type === "number") {
      if (widget.subform) {
        if (
          this.fixedWidgetMap[id.row] &&
          this.fixedWidgetMap[id.row][widget.subform] &&
          this.fixedWidgetMap[id.row][widget.subform][id.subrow] &&
          this.fixedWidgetMap[id.row][widget.subform][id.subrow][
          widget.match.field
          ]
        )
          this.fixedWidgetMap[id.row][widget.subform][id.subrow][
            widget.match.field
          ] = res.value;
      } else {
        this.fixedWidgetMap[id.row] &&
          (this.fixedWidgetMap[id.row][widget.match.field] = res.value);
      }
    }

    return (
      <div className="excel-grid-cell">
        {BsyUtils.createWidget({
          ...res,
        })}
      </div>
    );
  };

  formatText = (text) => {
    if (text?.type === "t") {
      if (BsyUtils.isExcelDateNumber(text.value)) {
        let inputTime = BsyUtils.excelDate2Date(text.value);
        return BsyUtils.date2Str(inputTime, 'yyyy-MM-dd HH:mm:ss')
      } else {
        return text.value ? BsyUtils.date2Str(new Date(text.value), 'yyyy-MM-dd HH:mm:ss') : '';
      }
    }
    return text.value;
  }

  renderTd = (id) => {
    const { errorData } = this.state;
    if (errorData) {
      if (id.value) {
        return (
          <td className="td-cell" colSpan={id.colspan} rowSpan={id.rowspan}>
            {this.colLabelTd(id)}
            {this.colCellTd(id)}
            {id.value.isnoRepeat && <BsySLoading></BsySLoading>}
          </td>
        );
      }

      return (
        <td colSpan={id.colspan} rowSpan={id.rowspan}>
          <span className="td-text">{this.formatText(id)}</span>
        </td>
      );
    }
    return (
      <td colSpan={id.colspan} rowSpan={id.rowspan}>
        <span className="td-text">{this.formatText(id)}</span>
      </td>
    );
  };

  getHeadsItemType = (item) => {
    if (item?.match?.type === "datetime") {
      return "t";
    }
    return '';
  }

  renderTr = () => {
    const { hasSubform, items, errorData, showHead, heads } = this.state;
    if (items.length === 0) {
      return <></>;
    }
    let bodyData = [];

    if (showHead) {
      this.fixedWidgetMap = [];

      for (let i = 0; i < items.length; i++) {
        let subRowspan = 1;
        let rowdata = Object.values(items[i]);

        this.fixedWidgetMap[i] = {};
        if (errorData) {
          this.fixedWidgetMap[i]["row"] = errorData[i].row;
        }

        if (hasSubform) {
          //取子表单占多少行
          for (let j = 0; j < rowdata.length; j++) {
            if (Array.isArray(rowdata[j])) {
              subRowspan =
                subRowspan > rowdata[j].length ? subRowspan : rowdata[j].length;
            }
          }

          for (let r = 0; r < subRowspan; r++) {
            let newdata = [];
            let rowspan = subRowspan;
            for (let j = 0; j < rowdata.length; j++) {
              if (errorData) {
                if (this.headerdata[j].subform) {
                  if (!this.fixedWidgetMap[i][this.headerdata[j].subform]) {
                    this.fixedWidgetMap[i][this.headerdata[j].subform] = [];
                    for (let rj = 0; rj < subRowspan; rj++) {
                      this.fixedWidgetMap[i][this.headerdata[j].subform].push(
                        {}
                      );
                    }
                  }
                }
              }

              if (Array.isArray(rowdata[j])) {
                let dd = [];
                if (rowdata[j][r]) {
                  dd = Object.values(rowdata[j][r]);
                  for (let subj = 0; subj < dd.length; subj++) {
                    newdata.push({
                      row: i,
                      subrow: r,
                      value: dd[subj],
                    });
                  }
                } else {
                  //遇到多个子表单同一行数据量不一致的情况处理
                  dd = Object.values(rowdata[j][0]);
                  for (let subj = 0; subj < dd.length; subj++) {
                    newdata.push({
                      subrow: r,
                      row: i,
                      value: "",
                    });
                  }
                }

                j = j + dd.length - 1;
              } else {
                if (r === 0) {
                  newdata.push({
                    row: i,
                    value: rowdata[j],
                    rowspan: rowspan,
                  });
                } else {
                  newdata.push([]);
                }
              }
            }
            bodyData.push(newdata);
          }
        } else {
          let newdata = [];
          for (let j = 0; j < rowdata.length; j++) {
            let item = heads[j];
            let type = this.getHeadsItemType(item);
            newdata.push({
              type,
              row: i,
              value: rowdata[j],
            });
          }
          bodyData.push(newdata);
        }
      }
    } else {
      let start = 1;
      if (hasSubform) {
        start = 2;
      }
      for (let i = start; i < items.length; i++) {
        bodyData.push(items[i]);
      }
    }

    let dataInex = 1;
    return (
      <>
        {bodyData.map((item, index) => {
          let rowspan = 1;
          /*
                        可能出现三种状态
                        0 子表单中的数据占行
                        1 单行数据 
                        大于1 有子表单合并数据的第一行
                    */
          for (let i = 0; i < item.length; i++) {
            if (
              index < bodyData.length - 1 &&
              Array.isArray(bodyData[index + 1][i]) &&
              !Array.isArray(bodyData[index][i])
            ) {
              rowspan = 2;
              while (1) {
                if (index + rowspan >= bodyData.length) {
                  break;
                }
                if (!Array.isArray(bodyData[index + rowspan][i])) {
                  break;
                }
                rowspan++;
              }
              break;
            } else {
              if (Array.isArray(bodyData[index][i])) rowspan = 0;
            }
          }
          return (
            <tr>
              {rowspan >= 1 ? (
                <td rowSpan={rowspan} className={"row-idx"}>
                  <span className={"row-num"}>{dataInex++}</span>
                  <span className={"row-label"}>
                    {React.language("import.rowHead")}
                  </span>
                </td>
              ) : (
                ""
              )}
              {item.map((id, index) => {
                if (Array.isArray(id)) {
                  return "";
                }

                return this.renderTd({ ...id, col: index });
              })}
            </tr>
          );
        })}
      </>
    );
  };

  render() {
    const { cssName } = this.options;
    return (
      <div className={cssName} ref={this.element}>
        <table cellPadding="0" cellSpacing="0">
          <thead>{this.renderHeader()}</thead>
          <tbody>{this.renderTr()}</tbody>
        </table>
      </div>
    );
  }
}

export class BsyFixedContent extends BsyWidget {
  static defaultProps = {
    baseCls: "bsy-fixed-content",
    values: [],
    type: "usergroup",
  };
  constructor(props) {
    super(props);
    this.state = {
      ...props,
    };

    this.element = React.createRef();
  }

  render() {
    const { type, values } = this.state;
    let config = {
      customCls: "line-wrapper",
      type: type === "usergroup" ? "user" : "dept",
    };

    let onStopEdit = (index, value, sec, context) => {
      let newValue = [...values];

      newValue[index].id = value;
      if (type === "usergroup" || type === "user") {
        newValue[index].name =
          window.userSelectMap[value].name ||
          window.userSelectMap[value].nickname;
        newValue[index].text =
          window.userSelectMap[value].name ||
          window.userSelectMap[value].nickname;
      } else {
        newValue[index].name = window.deptSelectMap[value].name;
        newValue[index].text = window.deptSelectMap[value].name;
      }

      newValue[index].updated = true;
      delete newValue[index].isMiss;
      delete newValue[index].isRepeat;
      this.setState({
        values: newValue,
      });
    };

    return (
      <div className="bsy-fixed-content" ref={this.element}>
        <div className="content-title">
          {values.map((item, index) => {
            if (item.isMiss || item.isRepeat) {
              return (
                <span key={"title" + index} className="style-red">
                  {item.name + (index < values.length - 1 ? "，" : "")}
                </span>
              );
            }
            if (item.updated) {
              return (
                <span key={"title" + index} className="style-green">
                  {item.name + (index < values.length - 1 ? "，" : "")}
                </span>
              );
            }
            return (
              <span key={"title" + index}>
                {item.name + (index < values.length - 1 ? "，" : "")}
              </span>
            );
          })}
        </div>
        <div className="content-wrapper">
          {values.map((item, index) => {
            config.value = item.id;
            return (
              <div key={"line" + index} className="content-line">
                {item.isMiss ? (
                  <>
                    <div className={"line-label style-red"}>
                      {React.language("import.contact.empty", {
                        name: item.text,
                      })}
                    </div>
                    {type === "usergroup" ? (
                      <BsyUser
                        {...config}
                        onStopEdit={(val, sec, context) => {
                          onStopEdit(index, val, sec, context);
                        }}
                      />
                    ) : (
                      <BsyDept
                        {...config}
                        onStopEdit={(val, sec, context) => {
                          onStopEdit(index, val, sec, context);
                        }}
                      />
                    )}
                  </>
                ) : item.isRepeat ? (
                  <>
                    <div className={"line-label style-red"}>
                      {React.language("import.contact.multi", {
                        name: item.text,
                      })}
                    </div>
                    {type === "usergroup" ? (
                      <BsyUser
                        {...config}
                        onStopEdit={(val, sec, context) => {
                          onStopEdit(index, val, sec, context);
                        }}
                      />
                    ) : (
                      <BsyDept
                        {...config}
                        onStopEdit={(val, sec, context) => {
                          onStopEdit(index, val, sec, context);
                        }}
                      />
                    )}
                  </>
                ) : item.updated ? (
                  <>
                    <div className={"line-label style-green"}>
                      {React.language("updated")}
                    </div>
                    {type === "usergroup" ? (
                      <BsyUser
                        {...config}
                        onStopEdit={(val, sec, context) => {
                          onStopEdit(index, val, sec, context);
                        }}
                      />
                    ) : (
                      <BsyDept
                        {...config}
                        onStopEdit={(val, sec, context) => {
                          onStopEdit(index, val, sec, context);
                        }}
                      />
                    )}
                  </>
                ) : (
                  ""
                )}
              </div>
            );
          })}
        </div>
        <div className={"content-footer"}>
          <BsyIconBtn
            text={React.language("ok")}
            type={"blue"}
            click={(event) => {
              this.props.onOk && this.props.onOk([...this.state.values]);
            }}
            mode={window.mode}
          />
          <BsyIconBtn
            text={React.language("cancel")}
            click={(event) => {
              this.props.onCancel && this.props.onCancel();
            }}
            mode={window.mode}
          />
        </div>
      </div>
    );
  }
}
